import { LandTechEndpoints, routedClient } from "react-migration/lib/persistence/apollo";

import { useWorkspacesQuery } from "@gql/sites-api/graphql";

export function useWorkspacesList() {
  const { data, ...queryState } = useWorkspacesQuery({
    client: routedClient,
    context: {
      endpoint: LandTechEndpoints.Sites,
    },
    /**
     * We want to first use the cache for speed, but we also want to want to hit
     * the network in case one of the workspaces has since been opened resulting
     * in a different order.
     */
    fetchPolicy: "cache-and-network",
  });

  return {
    list: data?.workspaces ?? [],
    ...queryState,
  };
}
